module.exports = __webpack_public_path__ + "img/delete.02853566.svg";